import { Section } from './Section'

export const FooterNavItems = ({ navigationItems }) =>
  navigationItems &&
  navigationItems.length > 0 &&
  navigationItems.map((section, index) => <Section key={index} section={section} />)

export default FooterNavItems
